import { useMutation } from "@tanstack/react-query";
import { ReviewService } from "../../services/review.service";

export const useReviewMutations = () => {
  const { mutate: deleteReview } = useMutation<any, Error, string>({
    mutationFn: async (id) => ReviewService.deleteReview(id),
  });

  const { mutate: reportReview } = useMutation<any, Error, string>({
    mutationFn: async (id) => ReviewService.reportReview(id),
  });

  return {
    deleteReview,
    reportReview,
  };
};
